const SldsBadge = () => {
    return (
        <>
        <span class="slds-badge">Default Badge</span>
        <span class="slds-badge slds-badge_inverse">Darker Badge</span>
        <span class="slds-badge slds-badge_lightest">Lightest Badge</span>
        <span class="slds-badge slds-theme_warning">Warning Badge</span>
        <span class="slds-badge slds-theme_error">Error Badge</span>
        <span class="slds-badge slds-theme_success">Success Badge</span>
        </>
    )
  }
export default SldsBadge;